export var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
    Method["PATCH"] = "PATCH";
})(Method || (Method = {}));
export var BodyType;
(function (BodyType) {
    BodyType["DEFAULT"] = "";
    BodyType["JSON"] = "application/json";
    BodyType["FORM"] = "application/x-www-form-urlencoded; charset=UTF-8";
})(BodyType || (BodyType = {}));
export var DefaultRequestOptions = {
    bodyType: BodyType.JSON,
    needsAuthorization: true,
    middleware: [],
    resolver: function (response) { return response.json(); },
};
